import {
  CONTROL_PANEL_MOBILE_QUERY,
  CONTROL_PANEL_TABS,
  CONTROL_PANEL_TABS_LABEL,
  CONTROL_PANEL_TITLE,
} from "./control-panel.constants";
import type { ControlPanelViewModel } from "./types-control-panel";

/** ViewModel da casca do Painel: o conteúdo de cada aba vem da rota filha (`Outlet`). */
export function useControlPanel(): ControlPanelViewModel {
  return {
    titulo: CONTROL_PANEL_TITLE,
    abas: [...CONTROL_PANEL_TABS],
    abasLabel: CONTROL_PANEL_TABS_LABEL,
    mobileQuery: CONTROL_PANEL_MOBILE_QUERY,
  };
}
